import { useProvider } from 'wagmi'

import { useContractAddresses } from 'hooks/gobblers/useContractAddresses'

import {
  ArtGobblers,
  ArtGobblers__factory,
  Goo,
  Goo__factory,
  Pages,
  Pages__factory,
} from '../../contracts'
import { useMemo } from 'react'

function useContracts(
  chainId: string,
): readonly [ArtGobblers | undefined, Goo | undefined, Pages | undefined] {
  const addresses = useContractAddresses(chainId)
  const provider = useProvider()

  const contractsTuple = useMemo(() => {
    const gobblerContract = addresses
      ? ArtGobblers__factory.connect(addresses.ART_GOBBLERS, provider)
      : undefined

    const gooContract = addresses ? Goo__factory.connect(addresses.GOO, provider) : undefined
    const pageContract = addresses ? Pages__factory.connect(addresses.PAGES, provider) : undefined

    return [gobblerContract, gooContract, pageContract] as const
  }, [addresses, provider])

  return contractsTuple
}

export default useContracts
